import { motion } from "framer-motion";

export const Manifesto = ({ manifesto, about }) => {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ad-surface border-y border-white/10">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-20"
        >
          <p className="text-ad-red text-xs sm:text-sm font-bold uppercase tracking-[0.3em] mb-5 flex items-center gap-3">
            <span className="h-px w-8 bg-ad-red" /> Why Choose Us
          </p>
          <h2 className="font-display text-4xl sm:text-6xl uppercase leading-[0.95] tracking-tight">
            {about?.heading}
          </h2>
          <p className="mt-6 text-white/60 text-lg leading-relaxed">{about?.text}</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {manifesto.map((m, i) => (
            <motion.div
              key={m.number}
              data-testid={`manifesto-${m.number}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.76, 0, 0.24, 1] }}
              className="group bg-ad-black p-10 sm:p-12 hover:bg-[#111] transition-colors"
            >
              <span className="font-display text-7xl sm:text-8xl text-ad-red block leading-none group-hover:translate-x-2 transition-transform duration-300">
                {m.number}
              </span>
              <h3 className="mt-8 font-display text-2xl sm:text-3xl uppercase tracking-tight metallic-text">
                {m.title}
              </h3>
              <p className="mt-4 text-white/60 leading-relaxed">{m.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
